import { useState } from "react";
import { postUpdateAvailableStockAPI } from "../../../../http/api/StaffStockAPI";


/**
 * 担当者在庫一覧 チェックした販売原票を管理するhook
 */
const useSelectedStocks = () => {

  /**
   * チェックした販売原票明細のリスト
   */
  const [selectedStocks, setSelectedStocks] = useState([]);

  /** チェックした在庫が存在するか? */
  const hasSelectedStocks = () => selectedStocks.length > 0;

  /**
   * その販売原票No・明細IDの在庫情報を取得する
   * @param {number} salesRecordNo 販売原票No
   * @param {number} salesDetailId 販売明細ID
   * @returns 明細の変更情報
   */
  const findStock = (salesRecordNo, salesDetailId) => {
    const res = selectedStocks.find((stock) =>
      stock.salesRecordNo == salesRecordNo && stock.salesDetailId == salesDetailId
    )
    return res
  };

  /** チェック状態を入れ替える */
  const setStockSelected = (salesRecordNo, salesDetailId, isAvailableStock, selected) => {

    const newList = [...selectedStocks];
    const newStocks = selected ? [{salesRecordNo, salesDetailId, isAvailableStock}] : [];

    setSelectedStocks([
      ...newList.filter((detail) =>
        detail.salesRecordNo != salesRecordNo || detail.salesDetailId != salesDetailId
      ),
      ...newStocks
    ]);
  }

  /** 非表示明細情報をクリアする */
  const clear = () => {
    setSelectedStocks([]);
  }

  /** 非表示情報を保存する */
  const saveAvailabilities = async (onSuccess = () => {}, onFailed = () => {}) => {
    try {
      await postUpdateAvailableStockAPI({
        stockAvailabilities: selectedStocks.map((stock) => ({...stock, isAvailableStock: !stock.isAvailableStock}))
      });
      onSuccess();
    }
    catch (e) {
      onFailed(e);
    }
  }

  const getSelectedSalesRecordNos = () => {
    return selectedStocks.map((stock) => stock.salesRecordNo);
  }

  const selectAllStocks = (allStocks) => {
    setSelectedStocks(
      allStocks.map(({salesRecordNo, salesDetailId, isAvailableStock}) => ({salesRecordNo, salesDetailId, isAvailableStock}))
    );
  }

  const isSelectedAll = (allStocks) => (
    allStocks.length > 0
      && allStocks.every((stock) => 
          selectedStocks.findIndex((selectedStock) =>
            selectedStock.salesRecordNo == stock.salesRecordNo
              && selectedStock.salesDetailId == stock.salesDetailId
          ) >= 0
        )
  );
    
  return {
    setStockSelected,
    clear,
    hasSelectedStocks,
    findStock,
    saveAvailabilities,
    getSelectedSalesRecordNos,
    isSelectedAll,
    selectAllStocks
  }
}

export default useSelectedStocks;
